import React from "react";
import {SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class ViewersIcon extends React.Component {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g transform="translate(-9.5, -8) scale(1.8)">
                    <path fill="currentColor" d="M57.771,119.465a7.477,7.477,0,0,0-6.571,4.38,7.118,7.118,0,0,0,13.141,0A7.477,7.477,0,0,0,57.771,119.465Zm0,7.118a2.738,2.738,0,1,1,2.738-2.738A2.738,2.738,0,0,1,57.771,126.583Z" transform="translate(-46 -112.465)" />
                    <circle fill="currentColor" cx="1.643" cy="1.643" r="1.643" transform="translate(10.1 9.738)" />
                </g>
            </SvgIcon>
        );
    }
}
